/** Static mock data only — no API. */

export interface MockBranch {
  id: string
  name: string
}

export interface MockWarehouse {
  id: string
  code: string
  name: string
  branchId: string
}

export interface MockItem {
  id: string
  code: string
  name: string
}

export interface MockBatch {
  id: string
  code: string
  reference: string
}

export const MOCK_BRANCHES: MockBranch[] = [
  { id: '1', name: 'Main branch' },
  { id: '2', name: 'East branch' },
  { id: '3', name: 'West branch' },
]

export const MOCK_WAREHOUSES: MockWarehouse[] = [
  { id: '1', code: 'WH1', name: 'Central warehouse', branchId: '1' },
  { id: '2', code: 'WH2', name: 'test warehouse2', branchId: '2' },
  { id: '3', code: 'WH3', name: 'test warehouse3', branchId: '3' },
  { id: '4', code: 'WH4', name: 'Receiving dock', branchId: '1' },
]

export const MOCK_ITEMS: MockItem[] = [
  { id: '101', code: 'SKU-001', name: 'Widget A' },
  { id: '102', code: 'SKU-002', name: 'Widget B' },
  { id: '103', code: 'SKU-003', name: 'Component C' },
]

export const MOCK_BATCHES_BY_ITEM: Record<string, MockBatch[]> = {
  '101': [
    { id: 'b1', code: 'B-2026-01', reference: 'Lot Jan' },
    { id: 'b2', code: 'B-2026-02', reference: 'Lot Feb' },
  ],
  '102': [{ id: 'b3', code: 'B-2026-03', reference: 'Lot Mar' }],
  '103': [{ id: 'b4', code: 'B-2026-04', reference: 'Lot Apr' }],
}

/** Simulated on-hand qty at destination warehouse for item+batch (before this receipt). */
export function mockStockAtDestination(destinationWarehouseId: string, itemId: string, batchId: string): number {
  if (!destinationWarehouseId || !itemId || !batchId) return 0
  const key = `${destinationWarehouseId}|${itemId}|${batchId}`
  const hash = key.split('').reduce((a, c) => a + c.charCodeAt(0), 0)
  return 40 + (hash % 120)
}
